import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterUtil } from '@seahorse/common';

@Component({
  selector: 'sh-not-authorized',
  templateUrl: './not-authorized.component.html',
  imports: [TranslateModule],
})
export class NotAuthorizedComponent implements OnInit {
  errorMessage?: string;
  constructor(
    private routerUtil: RouterUtil,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.routerUtil.currentModuleName = this.translate.instant(
      'shared.general.notAuthorized'
    );

    this.route.data.subscribe((data: Data) => {
      this.errorMessage = data['message'];
    });
  }
}
